import React from 'react';

import './TMIcon-style.css';

const TMIcon = () => {
    return <span className="tm-icon" />;
};

export default TMIcon;
